
export { OTPSettingComponent } from './otpsetting/otpsetting.component';
export { NotRefreshAppbarComponent } from './commonappbar/not-refresh-appbar/not-refresh-appbar.component';
export { AppNavigationBarComponent } from "./navigation-bar/navigation.component";
export { PageHeaderComponent } from "./commonappbar/page-header/page-header.component";
export { AppbarComponent } from "./commonappbar/appbar/appbar.component";
export { HeaderbarComponent } from "./commonappbar/headerbar/headerbarcomponent";
export { LanguagePageComponent } from "./language-page/language-page.component";
export { LanguageTextPageComponent } from "./language-text-page/language-text-page.component";
export { AccountLoginComponent } from './account-login/account-login.component'
export { AdsSliderComponent } from './ads-slider/ads-slider.component';
export { PageHeaderDetailComponent } from './page-header-detail/page-header-detail.component';
export { OtpServicePhoneComponent } from './otp-service-phone/otp-service-phone.component';
export { SharedTableComponent } from './shared-table/shared-table.component';
export { QrReaderComponent } from './qr-reader/qr-reader.component';